import Link from "next/link";
import { useTranslations } from "next-intl";
import type React from "react";
import { LINK_DATA, type RichTextLinkType } from "@/utils/constants";

interface RichTextDisplayProps {
  translationKey: string | null;
  linkType: RichTextLinkType;
  translationName: string;
  colorClass?: string;
}

const RichTextDisplay = ({
  translationKey,
  linkType,
  translationName,
  colorClass,
}: RichTextDisplayProps) => {
  const t = useTranslations(translationName);
  const linkData = LINK_DATA[linkType];

  const linkColor = colorClass ? colorClass : "blue-500";

  if (!t.has(translationKey)) {
    return <>{translationKey}</>;
  }

  return (
    <>
      {t.rich(translationKey, {
        [linkData.key]: (children: React.ReactNode) => (
          <Link
            className={`${linkColor} underline`}
            href={linkData.href}
            {...(linkData.target ? { target: linkData.target } : {})}
            {...(linkData.rel ? { rel: linkData.rel } : {})}
          >
            {children}
          </Link>
        ),
      })}
    </>
  );
};

export { RichTextDisplay };
